import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

import GroupSubscriptions from "../views/groupSubscriptions/GroupSubscriptions";
import GroupSubscriptionsCreation from "../views/groupSubscriptions/GroupSubscriptionsCreation";
import GroupSubscriptionsEditing from "../views/groupSubscriptions/GroupSubscriptionsEditing";

import Dashboard from "../views/dashboard/Dashboard";
import Login from "../views/login/Login";
import ResetPassword from "../views/login/ResetPassword";

import DetailedActivity from "../views/activity/DetailedActivity";

import Page404 from "../views/errors/Page404";

import Users from "../views/users/Users";
import UserCreation from "../views/users/UserCreation";
import UserEditing from "../views/users/UserEditing";
import ScheduledExportEditing from "../views/users/ScheduledExportEditing";

import ExportView from "../views/export/ExportView";

import Plans from "../views/plans/Plans.vue";
import PlanCreation from "../views/plans/PlanCreation.vue";
import PlanEditing from "../views/plans/PlanEditing.vue";
import PredictivePaywallHistory from "../views/plans/PredictivePaywallHistory";

import TiEvents from "../views/tickets/TiEvents.vue";
import TiEventCreation from "../views/tickets/TiEventCreation.vue";
import TiEventEditing from "../views/tickets/TiEventEditing.vue";

import Invites from "../views/invites/Invites.vue";
import InviteCreation from "../views/invites/InviteCreation.vue";
import InviteEditing from "../views/invites/InviteEditing.vue";
import InviteUsers from "../views/invites/InviteUsers.vue";

import Transactions from "../views/transactions/Transactions.vue";
import TransactionCreation from "../views/transactions/TransactionCreation.vue";
import TransactionsEditing from "../views/transactions/TransactionsEditing.vue";
import TransactionInfo from "../views/transactions/TransactionInfo.vue";

import Promos from "../views/promocodes/Promos.vue";
import PromoCreation from "../views/promocodes/PromoCreation.vue";
import PromoEditing from "../views/promocodes/PromoEditing.vue";
import PromoUsers from "../views/promocodes/PromoUsers.vue";

import Events from "../views/events/Events.vue";
import EventCreation from "../views/events/EventCreation.vue";
import EventEditing from "../views/events/EventEditing.vue";

import EmailTriggers from "../views/triggers/Triggers.vue";
import EmailTriggersCreation from "../views/triggers/TriggersCreation.vue";
import EmailTriggersEditing from "../views/triggers/TriggersEditing.vue";

import Resources from "../views/resources/Resources.vue";
import ResourcesEditing from "../views/resources/ResourcesEditing.vue";

import Content from "../views/content/Content.vue";

import Partners from "../views/partners/Partners.vue";
import PartnerCreation from "../views/partners/PartnerCreation.vue";
import PartnerEditing from "../views/partners/PartnerEditing.vue";

import Emails from "../views/emails/Emails.vue";
import EmailCreation from "../views/emails/EmailCreation.vue";
import EmailEditing from "../views/emails/EmailEditing.vue";

import Templates from "../views/templates/Templates.vue";
import TemplateCreation from "../views/templates/TemplateCreation.vue";
import TemplateEditing from "../views/templates/TemplateEditing.vue";

import PdfEditing from "../views/pdfs/PdfEditing.vue";

import Popups from "../views/popups/index.vue"
import loginPopup from "../views/popups/login.vue"
import passwordRecoveryPopup from "../views/popups/passwordRecovery.vue"
import subscribePopup from "../views/popups/subscribe.vue"
import signUpPopup from "../views/popups/signUp.vue"
import cardRegistration from "../views/popups/cardRegistration.vue"

import Invitation from "../views/onboarding/Invitation"
import Registration from "../views/onboarding/Registration"
import SetupStep1 from "../views/onboarding/SetupStep1"
import SetupStep2 from "../views/onboarding/SetupStep2"
import SetupStep3 from "../views/onboarding/SetupStep3"
import DashboardSettings from "@/views/dashboardSettings/DashboardSettings";
import PartnersResourceCreate from "../views/resources/PartnersResourceCreate";
import PartnersResourceEdit from "../views/resources/PartnersResourceEdit";
import BillingInfo from "@/views/billing/BillingInfo";
import BillingInfoCreate from "@/views/billing/BillingInfo";
import WallkitPricing from "../views/wallkit-pricing/WallkitPricing";
import WallkitPlanEditing from "../views/wallkit-pricing/WallkitPlanEditing";
import WallkitPlanCreation from "../views/wallkit-pricing/WallkitPlanCreation";
import Invoices from "../views/invoices/Invoices";
import CascadeAccess from "../views/cascadeAccess/CascadeAccess";
import ContentConversion from "../views/conversion/ContentConversion";


Vue.use(Router)

export default [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
    component: DefaultContainer,
    children: [
      {
        path: "dashboard",
        meta: { label: "Dashboard" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Dashboard
          },
          {
            path: "settings",
            name: "Dashboard Settings",
            component: DashboardSettings
          }
        ]
      },
      {
        path: "groups",
        meta: { label: "Groups" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: GroupSubscriptions
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: GroupSubscriptionsCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: GroupSubscriptionsEditing,
          }
        ]
      },
      {
        path: "users",
        meta: { label: "Audience" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Users,
          },
          {
            path: "create",
            component: UserCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: UserEditing,
          },
          {
            path: "edit/export/:id",
            meta: { label: "Edit export" },
            component: ScheduledExportEditing,
          }
        ]
      },
      {
        path: "export/:id",
        meta: { label: "Export" },
        component: ExportView,
      },
      {
        path: "plans",
        meta: { label: "Plans & Pricing" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Plans,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: PlanCreation,
          },
          {
            path: "actions/history/:id",
            meta: { label: "History" },
            component: PredictivePaywallHistory,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: PlanEditing,
          },
        ]
      },
      {
        path: "tievents",
        meta: { label: "Tickets & Events" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: TiEvents,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: TiEventCreation
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: TiEventEditing,
          },
        ]
      },
      {
        path: "promos",
        meta: { label: "Promo Codes" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Promos,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: PromoCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: PromoEditing,
            props: true
          },
          {
            path: "users/:id",
            meta: { label: "Users" },
            component: PromoUsers,
            props: true
          },
        ]
      },
      {
        path: "invites",
        meta: { label: "Invite Codes" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Invites,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: InviteCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: InviteEditing,
            props: true
          },
          {
            path: "users/:id",
            meta: { label: "Users" },
            component: InviteUsers,
            props: true
          },
        ]
      },
      {
        path: "content",
        meta: { label: "Content" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Content,
          },
          // {
          //   path: "create",
          //   meta: {label: "Content Creation"},
          //   name: "Content Creation",
          //   component: ContentCreation,
          // },
          // {
          //   path: "edit/:id",
          //   meta: {label: "Content Editing"},
          //   name: "Content Editing",
          //   component: ContentEditing,
          //   props: true
          // },
        ]
      },
      {
        path: "transactions",
        meta: { label: "Transactions" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Transactions,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: TransactionCreation,
          },
          {
            path: "edit/:id",
            meta: {label: "Edit"},
            component: TransactionsEditing,
          },
          {
            path: "info/:id",
            meta: { label: "Info" },
            component: TransactionInfo,
          }
        ]
      },
      {
        path: "resources",
        meta: { label: "Resources" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Resources,
          },
          {
            name: 'resource-edit',
            path: "edit",
            meta: { label: "Edit" },
            component: ResourcesEditing,
            children: [
              {
                path: "stripe-connect-live-confirmation",
                component: ResourcesEditing,
                redirect: (to) => {
                  return { name: 'resource-edit', query: { resource: to.query.state, mode: 'live', stripeCode: to.query.code } };
                }
              },
              {
                path: "stripe-connect-test-confirmation",
                component: ResourcesEditing,
                redirect: (to) => {
                  return { name: 'resource-edit', query: { resource: to.query.state, mode: 'test', stripeCode: to.query.code } };
                }
              }
            ]
          },
          // {
          //   path: "edit/:id",
          //   meta: {label: "Edit"},
          //   component: ResourcesEditing,
          // },

        ]
      },
      {
        path: "actions",
        meta: { label: "Automations" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Events,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: EventCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: EventEditing,
          },
        ]
      },
      {
        path: "triggers",
        meta: { label: "Triggers" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: EmailTriggers,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: EmailTriggersCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: EmailTriggersEditing,
          },
        ]
      },
      {
        path: "content-conversion",
        meta: { label: "Content Conversion" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: ContentConversion,
          }
        ]
      },
      {
        path: "emails",
        meta: { label: "E-mail Templates" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Emails,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: EmailCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: EmailEditing,
          }
        ]
      },
      {
        path: "pdf",
        meta: { label: "Edit PDF Template" },
        component: PdfEditing
      },

      {
        path: "partners",
        meta: { label: "Partners" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Partners,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: PartnerCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: {
              render(c) {
                return c("router-view")
              }
            },
            children: [
              {
                path: "",
                component: PartnerEditing,
                beforeEnter: ((to, from, next) => {
                  if (from.params && from.params.id && (from.meta.label === "Create Partner Resource" || from.meta.label === "Edit Partner Resource")) {
                    to.params.id = from.params.id
                  }
                  next()
                })
              },
              {
                path: "create-partner-resource",
                meta: { label: "Create Partner Resource" },
                component: PartnersResourceCreate,
              },
              {
                path: "edit-partner-resource/:resourceKey",
                meta: { label: "Edit Partner Resource" },
                component: PartnersResourceEdit,
              }
            ]
          },
        ]
      },
      {
        path: "wallkit-pricing",
        meta: { label: "Wallkit Pricing" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: WallkitPricing,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit Wallkit Plan" },
            component: WallkitPlanEditing
          },
          {
            path: "create",
            meta: { label: "Create Wallkit Plan" },
            component: WallkitPlanCreation
          }
        ]
      },
      {
        path: "templates",
        meta: { label: "Pop-up Templates" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Templates,
          },
          {
            path: "create",
            meta: { label: "Create" },
            component: TemplateCreation,
          },
          {
            path: "edit/:id",
            meta: { label: "Edit" },
            component: TemplateEditing,
          }
        ]
      },
      {
        path: "/popups",
        meta: { label: "Popups" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: Popups,
          },
          {
            path: "login",
            meta: { label: "Login" },
            component: loginPopup,
          },
          {
            path: "password-recovery",
            meta: { label: "Password Recovery" },
            component: passwordRecoveryPopup,
          },
          {
            path: "subscribe",
            meta: { label: "Subscribe" },
            component: subscribePopup,
          },
          {
            path: "sign-up",
            meta: { label: "Sign Up" },
            component: signUpPopup,
          },
          {
            path: "card-registration",
            meta: { label: "Card Registration" },
            component: cardRegistration,
          }
        ]
      },
      {
        path: "/setup-step1/:type",
        name: "Setup Step 1",
        component: SetupStep1
      },
      {
        path: "/setup-step2",
        name: "Setup Step 2",
        component: SetupStep2
      },
      {
        path: "/setup-step3/:type",
        name: "Setup Step 3",
        component: SetupStep3
      },
      {
        path: "/billing-info",
        name: "Billing",
        component: BillingInfo
      },
      {
        path: "/invoices",
        name: "Invoices",
        component: Invoices
      },
      {
        path: "cascade-access",
        meta: { label: "Cascade Access" },
        component: {
          render(c) {
            return c("router-view")
          }
        },
        children: [
          {
            path: "",
            component: CascadeAccess,
          }
        ]
      },
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: ResetPassword
  },
  {
    path: "/activate",
    name: "Invitation",
    component: Invitation
  },
  {
    path: "/onboarding-starter",
    name: "Registration",
    component: Registration
  },
  {
    path: "/detailed_activity",
    name: "DetailedActivity",
    component: DetailedActivity
  },
  {
    path: "*",
    name: "404",
    redirect: "/dashboard",
    component: Page404
  },
  {
    path: "/partners-registration",
    component: { render: (h) => h('div') },
    beforeEnter(to, from, next) {
      window.location.href = 'https://wallkit.net/#contact-anchor';
    }
  }
]
